export default __webpack_public_path__ + "static/media/5.ff4b0942.jpg";